import _ from "lodash";
import { flow, types } from "mobx-state-tree";
import { getEnv } from "~/mobx/utils/getEnv";
import { Breed } from "./Breed";
import type { BreedInstance, BreedSnapshotIn } from "./Breed";
import type { AxiosResponse } from "axios";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface BreedStoreInstance extends Instance<typeof BreedStore> {}
export interface BreedStoreSnapshotIn extends SnapshotIn<typeof BreedStore> {}
export interface BreedStoreSnapshotOut extends SnapshotOut<typeof BreedStore> {}

export const BreedStore = types
  .model("BreedStore", {
    map: types.map(Breed),
  })
  .actions((self) => {
    return {
      processOne(data: BreedSnapshotIn) {
        const existing = self.map.get(data.id);
        if (existing) {
          _.mergeWith(existing, data, (_, next) => {
            if (Array.isArray(next)) return next; // Treat arrays like atoms
          });
          return existing;
        }
        return self.map.put(data as BreedSnapshotIn);
      },
    };
  })
  .actions((self) => {
    return {
      processMany(dataList: BreedSnapshotIn[]) {
        return dataList.map((data) => {
          return self.processOne(data);
        });
      },
    };
  })
  .actions((self) => {
    return {
      getBreedList: flow<BreedInstance[], [string]>(
        function* getBreedList(speciesId): any {
          const env = getEnv(self);

          const response: AxiosResponse = yield env.baseAuthHttp.get(
            `species/${speciesId}/breeds`,
          );

          const breeds = response.data.data;

          response.data = self.processMany(breeds);

          return response.data;
        },
      ),
    };
  });
